import { ref, onMounted, computed, watch, nextTick } from "vue";
import CommonFooter from "@/components/commonFooter/index.vue";
import CommonHeader from "@/components/commonHeader/index.vue";
import { jointPlanApi, projectDocUploadUrl } from "../../../../api/commonApi";
import { useRoute, useRouter } from "vue-router";
import { SUCCEED_CODE } from "@/constants";
import { ElMessage, ElLoading } from "element-plus";
import {
  contractManage,
  orderManage,
  acceptanceManage,
  settleManage,
  acceptStatusDic,
  paymentMethodDic,
  pricingMethodDic,
  newContractRules,
  orderColumns,
  orderStatusDic,
  acceptanceColunms,
  acceptanceStatusDic,
} from "./config";
import { exportMaterialUrls } from "@/constants/index.js";
import { closeCurrentWidnow } from "../../../../utils/utils";
// 新建履约详情
export default {
  name: "NewContractPeformDetail",
  components: {
    CommonFooter,
    CommonHeader,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const renderDom = ref({});
    const routeParams = computed(() => route.query);
    const detailData = ref({
      contractName: "",
      projectName: "",
      purchaserEnterpriseName: "",
      firstParty: "",
      secondParty: "",
      supplierEnterpriseName: "",
      amount: "",
      selectCategoryCodes: "",
      startDate: "",
      pricingMethod: "",
      remarks: "",
      lcContractAttachmentIdList: "",
      materialPriceList: [],
    });
    const detailDataRef = ref();
    const newContractModal = ref(false);
    const newContractData = ref({
      bidPackage: "",
      bidResultId: "",
    });
    const newContractRef = ref();
    // 标包选择列表
    const selectBidList = ref([]);
    //
    const bidResultList = ref([]);
    // 编辑表格
    const editTableIndex = ref(-1);
    // 编辑表格数据
    const editTableData = ref({
      materialName: "",
      spec: "",
      orderCount: 0,
      purchaseCount: 0,
      unit: "",
      materialDesc: "",
      taxPrice: 0,
      taxTotalPrice: 0,
    });
    // table form ref
    const editTabeRef = ref();
    //
    const selectOptions = ref({
      selectCategoryCodes: [],
      lcContractAttachmentList: [],
      lcContractId: [],
    });
    // 订单弹窗
    const orderModal = ref(false);
    // 订单列表
    const orderList = ref([]);
    // 联采id
    const lcPlanId = computed(() => sessionStorage.getItem("lcPlanId"));
    // 验收单tabs列表
    const acceptanceTabsList = ref([]);
    // 当前验收单id
    const currentAcceptanceId = ref("");
    //
    const orderParams = ref({
      supplierEnterpriseName: "",
    });
    //
    const acceptanceModal = ref(false);
    //
    const acceptanceList = ref([]);

    const acceptanceParams = ref({
      contractName: "",
      supplierEnterpriseName: "",
      acceptStatus: "",
      lcPlanId: lcPlanId.value,
      pageSize: 10,
      currentPage: 1,
      lcContractId: "",
    });

    onMounted(() => {
      if (!routeParams.value.id && routeParams.value.type === "1") {
        newContractModal.value = true;
      }
      setRenderDom();
    });

    watch(
      editTableData,
      () => {
        if (routeParams.value.type === "1") {
          editTableData.value.taxTotalPrice =
            editTableData.value.purchaseCount * editTableData.value.taxPrice ||
            0;
        }
        if (routeParams.value.type === "2") {
          editTableData.value.taxTotalPrice =
            editTableData.value.orderCount * editTableData.value.taxPrice || 0;
        }
      },
      { deep: true }
    );

    // 初始化数据
    const setRenderDom = () => {
      switch (routeParams.value.type) {
        case "1":
          renderDom.value = contractManage;
          detailData.value = JSON.parse(
            JSON.stringify(contractManage.formData)
          );
          getBidPackageList();
          selectCategoryList();
          getFileListByType();
          routeParams.value.id && initLcContract();
          break;

        case "2":
          renderDom.value = orderManage;
          detailData.value = JSON.parse(JSON.stringify(orderManage.formData));
          getContractList();
          break;

        case "3":
          renderDom.value = acceptanceManage;
          detailData.value = JSON.parse(
            JSON.stringify(acceptanceManage.formData)
          );
          getContractList();
          break;

        case "4":
          renderDom.value = settleManage;
          detailData.value = JSON.parse(JSON.stringify(settleManage.formData));
          getContractList();
          break;

        default:
          break;
      }
    };

    // 标包列表
    const getBidPackageList = () => {
      jointPlanApi
        .getBidPackageList({ lcPlanId: lcPlanId.value })
        .then((res) => {
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            selectBidList.value = data;
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 中标结果列表
    const getBidWinningList = () => {
      newContractData.value.bidResultId = "";
      jointPlanApi
        .getBidWinningList({
          lcBidPackageId: newContractData.value.bidPackage,
        })
        .then((res) => {
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            bidResultList.value = data;
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 初始化合同信息
    const initLcContract = () => {
      jointPlanApi
        .initLcContract({
          lcBidWinningId: newContractData.value.bidResultId,
          lcPlanId: lcPlanId.value,
          lcContractId: routeParams.value.id,
        })
        .then((res) => {
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            detailData.value = data;
            detailData.value.selectCategoryCodes = data.categoryList.map(
              (item) => item.tCategoryId
            );
            detailData.value.dataRange = [data?.startDate, data?.endDate];
            newContractData.value = {
              bidPackage: "",
              bidResultId: "",
            };
            detailData.value.bidPackageName = data.bidName
              ? data.name + " - " + data.bidName
              : data.name;
            editTableData.value.lcContractId = data.id;
            newContractModal.value = false;
            getLcContractMaterialList()
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 初始化订单信息
    const initLcOrder = () => {
      jointPlanApi
        .initLcOrder({
          lcPlanId: lcPlanId.value,
          lcContractId: detailData.value.lcContractId,
        })
        .then((res) => {
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            detailData.value = Object.assign(detailData.value, data);
            editTableData.value.lcOrderId = data.id;
            getLcOrderMaterialList();
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 初始化验收单信息
    const initLcAccept = () => {
      jointPlanApi
        .initLcAccept({
          lcOrderId: detailData.value.lcOrderId,
        })
        .then((res) => {
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            detailData.value = Object.assign(detailData.value, data);
            detailData.value.materialPriceList =
              data?.orderMaterialPrice?.materialPriceList;
            if (
              Array.isArray(detailData.value.materialPriceList) &&
              detailData.value.materialPriceList.length
            ) {
              const sumObj = {
                number: "合计",
                orderCount: data?.orderMaterialPrice?.orderTotalCount,
                taxTotalPrice: data?.orderMaterialPrice?.taxTotalPrice,
              };
              detailData.value.materialPriceList.unshift(sumObj);
            }
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 标包列表
    const selectCategoryList = () => {
      jointPlanApi
        .selectCategoryList({ lcPlanId: lcPlanId.value })
        .then((res) => {
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            selectOptions.value.selectCategoryCodes = data?.map((item) => {
              return {
                label:
                  item.fCategoryName +
                  "-" +
                  item.sCategoryName +
                  "-" +
                  item.tCategoryName,
                value: item.tCategoryId,
                ...item,
              };
            });
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 导出报价清单
    const handleDownloadFile = () => {
      if (detailData.value.id) {
        switch (routeParams.value.type) {
          case "1":
            window.open(
              exportMaterialUrls.contractUrl +
                "?lcContractId=" +
                routeParams.value.id,
              "_blank"
            );
            break;
          case "2":
            window.open(
              exportMaterialUrls.orderUrl +
                "?lcOrderId=" +
                routeParams.value.id,
              "_blank"
            );
            break;
          case "3":
            window.open(
              exportMaterialUrls.acceptUrl +
                "?lcAcceptId=" +
                routeParams.value.id,
              "_blank"
            );
            break;
          case "4":
            window.open(
              exportMaterialUrls.settleUrl +
                "?lcSettlementId=" +
                routeParams.value.id,
              "_blank"
            );
            break;

          default:
            break;
        }
      }
    };

    // 履约列表
    const goListPage = () => {
      router.push({ path: "/jointPlan/detail", query: { id: lcPlanId.value } });
    };

    // 编辑表格列
    const setTableEditRow = (index, row) => {
      if (index) {
        editTableIndex.value = index;
        editTableData.value = row;
      } else {
        detailData.value.materialPriceList.push({
          materialName: "",
          spec: "",
          orderCount: null,
          unit: "",
          materialDesc: "",
          taxPrice: null,
          taxTotalPrice: null,
          purchaseCount: null,
        });
        editTableIndex.value = detailData.value.materialPriceList.length - 1;
      }
    };

    // 取消编辑
    const cancelEditRow = (index) => {
      if (!detailData.value.materialPriceList[index].id) {
        detailData.value.materialPriceList.splice(index, 1);
      }
      editTableIndex.value = -1;
      editTableData.value = {
        materialName: "",
        spec: "",
        orderCount: null,
        unit: "",
        materialDesc: "",
        taxPrice: null,
        taxTotalPrice: null,
        purchaseCount: null,
      };
    };

    // 新建合同下一步
    const handleNextStep = async () => {
      if (!newContractRef.value) return;
      await newContractRef.value.validate((valid) => {
        if (valid) {
          initLcContract();
        } else {
          ElMessage.error("请检查必填项！");
        }
      });
    };

    // 关闭新建合同
    const closeNewContractModal = () => {
      closeCurrentWidnow();
    };

    // 日期区间改变
    const handleChangeDate = (date) => {
      if (Array.isArray(date)) {
        detailData.value.startDate = date[0];
        detailData.value.endDate = date[1];
      }
    };

    // 删除合同材料价格
    const deleteContractMaterial = (id) => {
      jointPlanApi.deleteContractMaterial({ id: id }).then((res) => {
        const { statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          getLcContractMaterialList();
          ElMessage.success(message);
        } else {
          ElMessage.error(message);
        }
      });
    };

    // 删除订单材料价格
    const deleteOrderMaterial = (id) => {
      jointPlanApi.deleteOrderMaterial({ id: id }).then((res) => {
        const { statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          getLcOrderMaterialList();
          ElMessage.success(message);
        } else {
          ElMessage.error(message);
        }
      });
    };

    // 删除验收单材料价格
    const deleteAcceptMaterial = (id) => {
      jointPlanApi.deleteAcceptMaterial({ id: id }).then((res) => {
        const { statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          ElMessage.success(message);
        } else {
          ElMessage.error(message);
        }
      });
    };

    // 删除结算单材料价格
    const deleteSettlementMaterial = (id) => {
      jointPlanApi.deleteSettlementMaterial({ id: id }).then((res) => {
        const { statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          ElMessage.success(message);
        } else {
          ElMessage.error(message);
        }
      });
    };

    // 点击删除材料
    const handleDeleteMaterial = (id) => {
      switch (routeParams.value.type) {
        case "1":
          deleteContractMaterial(id);
          break;

        case "2":
          deleteOrderMaterial(id);
          break;

        case "3":
          deleteAcceptMaterial(id);
          break;

        case "4":
          deleteSettlementMaterial(id);
          break;

        default:
          break;
      }
    };

    //  新增-编辑合同材料价格
    const saveOrUpdateContractMaterial = () => {
      jointPlanApi
        .saveOrUpdateContractMaterial(editTableData.value)
        .then((res) => {
          const { statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            ElMessage.success(message);
            getLcContractMaterialList();
            editTableIndex.value = -1;
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 新增-编辑订单材料价格
    const saveOrUpdateOrderMaterial = () => {
      jointPlanApi
        .saveOrUpdateOrderMaterial(editTableData.value)
        .then((res) => {
          const { statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            ElMessage.success(message);
            getLcOrderMaterialList();
            editTableIndex.value = -1;
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 新增-编辑验收单材料价格
    const saveOrUpdateAcceptMaterial = (id) => {
      jointPlanApi.saveOrUpdateAcceptMaterial({ id: id }).then((res) => {
        const { statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          ElMessage.success(message);
          editTableIndex.value = -1;
        } else {
          ElMessage.error(message);
        }
      });
    };

    // 新增-编辑结算单材料价格
    const saveOrUpdateSettlementMaterial = (id) => {
      jointPlanApi.saveOrUpdateSettlementMaterial({ id: id }).then((res) => {
        const { statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          ElMessage.success(message);
          editTableIndex.value = -1;
        } else {
          ElMessage.error(message);
        }
      });
    };

    // 保存材料表格编辑框
    const handleSaveTableEditRow = async () => {
      if (!editTabeRef.value) return;
      await editTabeRef.value[0].validate((valid) => {
        if (valid) {
          switch (routeParams.value.type) {
            case "1":
              saveOrUpdateContractMaterial();
              break;
            case "2":
              saveOrUpdateOrderMaterial();
              break;
            case "3":
              saveOrUpdateAcceptMaterial();
              break;
            case "4":
              saveOrUpdateSettlementMaterial();
              break;

            default:
              break;
          }
          editTableData.value = {
            materialName: "",
            spec: "",
            orderCount: null,
            unit: "",
            materialDesc: "",
            taxPrice: null,
            taxTotalPrice: null,
            purchaseCount: null,
          };
        }
      });
    };

    //  查询当前采购企业对应的合同列表
    const getContractList = () => {
      jointPlanApi.getContractList({ lcPlanId: lcPlanId.value }).then((res) => {
        const { data, statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          selectOptions.value.lcContractId = data.map((item) => {
            return {
              ...item,
              label: item.contractName,
              value: item.id,
            };
          });
        } else {
          ElMessage.error(message);
        }
      });
    };

    //  查询已发货、验收2个状态的订单列表
    const getOrderlist = () => {
      jointPlanApi
        .getOrderlist({
          lcPlanId: lcPlanId.value,
          lcContractId: detailData.value.lcContractId,
          pageSize: 100,
          supplierEnterpriseName: orderParams.value.supplierEnterpriseName,
        })
        .then((res) => {
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            orderList.value = data;
            orderModal.value = true;
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 弹窗选择订单
    const openModalOrder = () => {
      if (detailData.value.lcContractId) {
        getOrderlist();
      } else {
        ElMessage.warning("请先选择合同！");
      }
    };

    const closeOrderModal = () => {
      orderList.value = [];
      orderModal.value = false;
    };

    //
    const modalSelectOrder = (row) => {
      nextTick(() => {
        detailData.value.lcOrderId = row.id;
        detailData.value.lcOrderName = row.orderNo;
        initLcAccept();
      });
      closeOrderModal();
    };

    // 保存合同相关信息
    const updateLcContract = () => {
      jointPlanApi.updateLcContract(detailData.value).then((res) => {
        const { statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          ElMessage.success(message || "操作成功！");
          goListPage();
        } else {
          ElMessage.error(message || "操作失败！");
        }
      });
    };

    // 保存订单相关信息
    const updateLcOrder = () => {
      jointPlanApi.updateLcOrder(detailData.value).then((res) => {
        const { statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          ElMessage.success(message || "操作成功！");
          goListPage();
        } else {
          ElMessage.error(message || "操作失败！");
        }
      });
    };

    // 新建验收单
    const saveLcAccept = () => {
      jointPlanApi
        .saveLcAccept({
          lcOrderId: detailData.value.lcOrderId,
          lcPlanId: lcPlanId.value,
          remarks: detailData.value.remarks,
        })
        .then((res) => {
          const { statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            ElMessage.success(message || "操作成功！");
            goListPage();
          } else {
            ElMessage.error(message || "操作失败！");
          }
        });
    };

    // 新建结算单
    const saveSettlement = () => {
      detailData.value.lcAcceptIdList = acceptanceTabsList.value.map(
        (item) => item.id
      );
      detailData.value.lcPlanId = lcPlanId.value;
      jointPlanApi.saveSettlement(detailData.value).then((res) => {
        const { statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          ElMessage.success(message || "操作成功！");
          goListPage();
        } else {
          ElMessage.error(message || "操作失败！");
        }
      });
    };

    // 点击保存编辑
    const handleSaveEditBtn = () => {
      switch (routeParams.value.type) {
        case "1":
          updateLcContract();
          break;
        case "2":
          updateLcOrder();
          break;
        case "3":
          saveLcAccept();
          break;
        case "4":
          saveSettlement();
          break;

        default:
          break;
      }
    };

    // 提交新增、编辑数据
    const handleCommitData = async () => {
      if (!detailDataRef.value) return;
      await detailDataRef.value.validate((valid) => {
        if (valid) {
          handleSaveEditBtn();
        } else {
          ElMessage.error("请检查必填项！");
        }
      });
    };

    // 选择合同
    const selectContract = (select) => {
      switch (routeParams.value.type) {
        case "2":
          initLcOrder();
          break;

        case "3":
          // 清空订单选择
          detailData.value = {
            lcContractId: select,
          };
          break;

        case "4": {
          let selectItem = selectOptions.value.lcContractId.find(
            (item) => item.value === select
          );
          detailData.value = Object.assign(detailData.value, {
            projectName: selectItem.projectName,
            contractName: select.contractName,
            purchaserEnterpriseName: selectItem.purchaserEnterpriseName,
            supplierEnterpriseName: selectItem.supplierEnterpriseName,
          });
          detailData.value.contractName = selectItem.contractName;
          break;
        }

        default:
          break;
      }
    };

    // 删除验收单tab
    const deleteAcceptanceTab = (index) => {
      acceptanceTabsList.value.splice(index, 1);
      if (acceptanceTabsList.value.length) {
        changeAcceptanceId(acceptanceTabsList.value[0].id);
      }
    };

    // 更改验收单id
    const changeAcceptanceId = (id) => {
      currentAcceptanceId.value = id;
      getAcceptInfo(currentAcceptanceId.value);
    };

    // 选择验收单
    const selectAcceptance = (row) => {
      if (
        Array.isArray(acceptanceTabsList.value) &&
        !acceptanceTabsList.value.find((item) => item.id === row.id)
      ) {
        acceptanceTabsList.value.push({ id: row.id, acceptNo: row.acceptNo });
        changeAcceptanceId(row.id);
      }
    };

    const openAcceptanceModal = () => {
      if (detailData.value.lcContractId) {
        getAcceptList();
      } else {
        ElMessage.error("请先选择合同！");
      }
    };

    // 查询合同材料价格列表
    const getLcContractMaterialList = () => {
      jointPlanApi
        .getLcContractMaterialList({
          lcContractId: detailData.value.id || routeParams.value.id,
        })
        .then((res) => {
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            detailData.value.materialPriceList = data?.materialPriceList;
            if (
              Array.isArray(data.materialPriceList) &&
              data.materialPriceList.length
            ) {
              const materialTotal = {
                number: "合计",
                purchaseCount: data.purchaseTotalCount,
                taxTotalPrice: data.taxTotalPrice,
              };
              detailData.value.materialPriceList.unshift(materialTotal);
            }
          } else {
            ElMessage.error(message || "操作失败！");
          }
        });
    };

    // 查询订单材料价格列表
    const getLcOrderMaterialList = () => {
      jointPlanApi
        .getLcOrderMaterialList({ lcOrderId: detailData.value.id })
        .then((res) => {
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            detailData.value.materialPriceList = data?.materialPriceList;
            if (
              Array.isArray(data.materialPriceList) &&
              data.materialPriceList.length
            ) {
              const materialTotal = {
                number: "合计",
                purchaseCount: data.orderTotalCount,
                taxTotalPrice: data.taxTotalPrice,
              };
              detailData.value.materialPriceList.unshift(materialTotal);
            }
          } else {
            ElMessage.error(message || "操作失败！");
          }
        });
    };

    // 查询合同材料价格列表
    const getFileListByType = () => {
      jointPlanApi
        .getFileListByType({
          lcPlanId: lcPlanId.value,
          fileType: "SIGNED_DOCUMENT",
          pageSize: 100,
        })
        .then((res) => {
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            selectOptions.value.lcContractAttachmentIdList = data.map(
              (item) => {
                return {
                  label: item.fileName,
                  value: item.id,
                  ...item,
                };
              }
            );
          } else {
            ElMessage.error(message || "操作失败！");
          }
        });
    };

    // 下载材料模板
    const downloadMaterialTemplate = () => {
      switch (routeParams.value.type) {
        case "1":
          window.open(
            "https://m2-joint-procurement.obs.cn-north-1.myhuaweicloud.com/template/%E5%90%88%E5%90%8C%E6%9D%90%E6%96%99%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx",
            "_blank"
          );
          break;

        case "2":
          window.open(
            "https://m2-joint-procurement.obs.cn-north-1.myhuaweicloud.com/template/%E8%AE%A2%E5%8D%95%E6%9D%90%E6%96%99%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx",
            "_blank"
          );
          break;

        default:
          break;
      }
    };

    // 上传成功
    const uploadMaterialFileSuccess = (response) => {
      const { statusCode, message } = response;
      if (statusCode === SUCCEED_CODE) {
        ElMessage.success(message || "上传成功！");
      } else {
        ElMessage.error(message || "上传失败！");
      }
      ElLoading.service({
        target: ".tab_info",
        fullscreen: true,
      }).close();
    };

    // 上传中
    const uploadMaterialFileProgress = () => {
      ElLoading.service({
        target: ".tab_info",
        fullscreen: true,
      });
    };

    // 查询验收单
    const getAcceptList = () => {
      acceptanceParams.value.lcContractId = detailData.value.lcContractId;
      jointPlanApi.getAcceptList(acceptanceParams.value).then((res) => {
        const { data, statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          acceptanceList.value = data;
          acceptanceModal.value = true;
        } else {
          ElMessage.error(message || "操作失败！");
        }
      });
    };

    // 查询验收单详情
    const getAcceptInfo = (id) => {
      jointPlanApi.getAcceptInfo({ lcAcceptId: id }).then((res) => {
        const { data, statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          detailData.value.acceptList = [data];
          if (data.materialPrice) {
            detailData.value.materialPriceList =
              data?.materialPrice?.materialPriceList;
            if (detailData.value.materialPriceList.length) {
              const sumObj = {
                number: "合计",
                orderCount: data?.materialPrice.orderTotalCount,
                taxTotalPrice: data?.materialPrice.taxTotalPrice,
              };
              detailData.value.materialPriceList.unshift(sumObj);
            }
          }
        } else {
          ElMessage.error(message || "操作失败！");
        }
      });
    };

    // 上传付款凭证
    const uploadSuccess = (response, file, fileList, type) => {
      switch (type) {
        case "paymentVoucherFileList":
          detailData.value.paymentVoucherFileId = response?.data[0]?.id;
          detailData.value.paymentVoucherFileList = [
            {
              ...response?.data[0],
              name: response?.data[0].fileName,
              path: response?.data[0].filePath,
            },
          ];
          break;

        case "invoiceFileList":
          detailData.value.invoiceFileIdList = fileList.map((item) => {
            return item.response.data[0]?.id;
          });
          break;

        default:
          break;
      }
      const { statusCode, message } = response;
      if (statusCode === SUCCEED_CODE) {
        ElMessage.success(message);
      } else {
        ElMessage.error(message);
      }
    };

    // 删除文件
    const removeFile = (fileList, type) => {
      switch (type) {
        case "paymentVoucherFileList":
          detailData.value.paymentVoucherFileId = "";
          break;

        case "invoiceFileIdList":
          detailData.value.invoiceFileIdList = fileList.map((item) => {
            return item.response.data[0].id;
          });
          break;

        default:
          break;
      }
    };

    // 预览附件
    const priviewFile = (filePath) => {
      if (filePath.path) {
        window.open(filePath.path);
      } else {
        let path = filePath.response.data.find(
          (item) => item.fileName === filePath.name
        );
        window.open(path.filePath);
      }
    };

    return {
      renderDom,
      detailData,
      acceptStatusDic,
      paymentMethodDic,
      pricingMethodDic,
      routeParams,
      newContractModal,
      newContractData,
      newContractRules,
      selectBidList,
      bidResultList,
      editTableIndex,
      detailDataRef,
      editTableData,
      editTabeRef,
      newContractRef,
      selectOptions,
      orderModal,
      orderColumns,
      orderStatusDic,
      orderList,
      acceptanceStatusDic,
      acceptanceTabsList,
      currentAcceptanceId,
      orderParams,
      acceptanceModal,
      acceptanceList,
      acceptanceColunms,
      acceptanceParams,
      projectDocUploadUrl,
      handleDownloadFile,
      goListPage,
      closeNewContractModal,
      setTableEditRow,
      getBidPackageList,
      handleNextStep,
      getBidWinningList,
      handleCommitData,
      handleChangeDate,
      selectCategoryList,
      handleDeleteMaterial,
      handleSaveTableEditRow,
      openModalOrder,
      closeOrderModal,
      handleSaveEditBtn,
      selectContract,
      modalSelectOrder,
      deleteAcceptanceTab,
      changeAcceptanceId,
      getOrderlist,
      openAcceptanceModal,
      cancelEditRow,
      downloadMaterialTemplate,
      uploadMaterialFileSuccess,
      getAcceptList,
      uploadMaterialFileProgress,
      selectAcceptance,
      uploadSuccess,
      removeFile,
      priviewFile,
    };
  },
};
